import { z } from 'zod'

export const authRegisterSchema = z.object({
  accessCode: z.string().min(1, 'Preencha o código de acesso'),
  name: z.string().min(1, 'Preencha seu nome'),
  lastName: z.string().min(1, 'Preencha seu sobrenome'),
  email: z
    .string()
    .min(1, 'Preencha um e-mail')
    .email('Informe um e-mail válido'),
  password: z
    .string()
    .min(1, 'Preencha uma senha')
    .min(6, 'Senha muito fraca!'),
  confirmPassword: z.string().min(1, 'Necessário a confirmação da senha'),
}).refine((data) => data.password === data.confirmPassword, {
  message: 'Senhas devem ser iguais',
  path: ['confirmPassword'],
})

export type AuthRegisterSchema = z.infer<typeof authRegisterSchema>